/**
 * Tailwind class merger — combines clsx for conditional classes
 * with tailwind-merge for resolving conflicting Tailwind utilities.
 *
 * Usage:
 *   <div className={cn('p-4 rounded-xl', isActive && 'bg-white/20', className)}>
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
